import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
export default {
  name: "lifestyle-tag",
  data: function data() {
    return {
      searchForm: {
        // pn: 1,
        // ps: 20,
        // keywords: "",
      },
      // 搜索表单

      form: {
        tag_id: '',
        content_zh: '',
        content_en: '',
        content_tw: ''
      },
      rules: {
        tag_id: [{
          required: true,
          message: '请选择活动标签',
          trigger: 'change'
        }],
        content_zh: [{
          required: true,
          message: '请填写活动详情（中）',
          trigger: 'blur'
        }],
        content_en: [{
          required: true,
          message: '请填写活动详情（英）',
          trigger: 'blur'
        }],
        content_tw: [{
          required: true,
          message: '请填写活动详情（繁）',
          trigger: 'blur'
        }]
      },
      dialogVisible: false,
      tableLoading: false,
      tableData: [{}],
      // 表格数据
      total: 0,
      tagLoading: false,
      tagList: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getTagList();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    addBtn: function addBtn() {
      this.form = {
        tag_id: '',
        content_zh: '',
        content_en: '',
        content_tw: ''
      };
      this.dialogVisible = true;
    },
    remoteMethod: function remoteMethod(query) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2.getTagList(query);
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getTagList: function getTagList(query) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this3.tagLoading = true;
              _context3.n = 1;
              return _this3.$api.getLifestyleTagList({
                pn: 1,
                ps: 20,
                keywords: query
              });
            case 1:
              res = _context3.v;
              _this3.tagLoading = false;
              _this3.tagList = res.data.list;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (type === "search") {
                _this4.searchForm.pn = 1;
              }
              _this4.tableLoading = true;
              _context4.n = 1;
              return _this4.$api.getLifestyleActivityList(_this4.searchForm);
            case 1:
              res = _context4.v;
              _this4.tableData = res.data;
              _this4.tableLoading = false;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    updateSort: function updateSort(row) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this5.$api.updateLifestyleActivity(row);
            case 1:
              _this5.$message.success("操作成功");
              _this5.getData();
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    updateDialog: function updateDialog(row) {
      this.form = row;
      this.dialogVisible = true;
    },
    save: function save() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _this6.$refs.ruleForm.validate(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(valid) {
                  return _regenerator().w(function (_context6) {
                    while (1) switch (_context6.n) {
                      case 0:
                        if (!valid) {
                          _context6.n = 4;
                          break;
                        }
                        if (!_this6.form.tag_id) {
                          _context6.n = 2;
                          break;
                        }
                        _context6.n = 1;
                        return _this6.$api.updateLifestyleActivity(_this6.form);
                      case 1:
                        _context6.n = 3;
                        break;
                      case 2:
                        _context6.n = 3;
                        return _this6.$api.updateLifestyleActivity(_this6.form);
                      case 3:
                        _this6.dialogVisible = false;
                        _this6.form = {
                          tag_id: '',
                          content_zh: '',
                          content_en: '',
                          content_tw: ''
                        };
                        _this6.getData();
                        _context6.n = 5;
                        break;
                      case 4:
                        console.log('error submit!!');
                        return _context6.a(2, false);
                      case 5:
                        return _context6.a(2);
                    }
                  }, _callee6);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    changeStatus: function changeStatus(row) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var status;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              status = null;
              if (row.status == 1) {
                status = 2;
              } else {
                status = 1;
              }
              _context8.n = 1;
              return _this7.$api.updateLifestyleActivity({
                id: row.id,
                status: status
              });
            case 1:
              _this7.getData();
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    deleteItem: function deleteItem(row) {
      var _this8 = this;
      this.$confirm("删除， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _context9.n = 1;
              return _this8.$api.updateLifestyleActivity({
                id: row.id,
                status: 0
              });
            case 1:
              _this8.$message.success("操作成功");
              _this8.getData();
            case 2:
              return _context9.a(2);
          }
        }, _callee9);
      }))).catch(function () {});
    }
  }
};